import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export const useLoginForm = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try { await login(email, password); }
    catch (err) { setError(apiError(err, "Login failed. Check your credentials.")); }
    finally { setLoading(false); }
  };

  return { email, setEmail, password, setPassword, error, loading, onSubmit };
};
